import React, { Component } from 'react';
import DB from '../db.js'
import {
	BrowserRouter as Router,// eslint-disable-line
	NavLink
} from 'react-router-dom';
var moment = require('moment');

class Navbar extends Component {

	constructor(props) {
		
		super(props);
		this.state = {
		};		

		// Bind Allow access by "this" into the function
		this.submitSearchEngine = this.submitSearchEngine.bind(this);
	}

	submitSearchEngine(e){
		e.preventDefault();
		let search = document.querySelector("#inputSearch"),
			searchVal = search.value,
			weekOut = this.props.filter().week;
		
		if(/^\d*$/.test(searchVal)){ // Searching by a week number
			console.info("its a week number");
			weekOut = searchVal;
			
		} else if(/^\d{1,2}[./-]\d{1,2}[./-]\d{2,4}$/.test(searchVal)){ // Searching by a date
			let sd = searchVal.split(/[./-]/)
			searchVal = searchVal.replace(/\//g, "-").replace(/\./g, "-")
			let weekNbr = moment(sd[2] + "-" + sd[0] + "-" + sd[1]).week();
			weekOut = weekNbr;
		}
		search.value = ''
		this.props.filter(Object.assign(this.props.filter(), {"week": weekOut}))
		
		//this.props.history.push("/note/"+weekOut, {weekNbr: weekOut})
	}

	render() {
		return (
			<nav className="fixed-top navbar navbar-expand-lg navbar-light bg-light border-bottom">
				<span className="navbar-brand cursorPointer" onClick={() => {this.props.filter(false)}}>Work Journal</span>
				<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>
				<div className="collapse navbar-collapse justify-content-end" id="navbarNavAltMarkup">
					<form className="d-flex mr-4" onSubmit={this.submitSearchEngine}>
						<button type="button" className={(parseInt(this.props.filter().week, 10)!==parseInt(moment().week(), 10)? "visible" : "invisible") + " btn btn-outline-secondary mr-4"} onClick={() => {
							this.props.filter(Object.assign(this.props.filter(), {"week": moment().week()}))
						}}>Back to current week</button>
						<div className="input-group">
								<input type="text" className="form-control" placeholder="06-22-18 or 29" aria-label="Recipient's username" aria-describedby="button-addon2" id="inputSearch"></input>
								<div className="input-group-append">
									<button className="btn btn-outline-secondary" type="submit" id="button-addon2">Search</button>
								</div>
						</div>
					</form>
					<div className="navbar-nav">
						<div className="dropdown">
							<button className="btn btn-secondary dropdown-toggle bg-light text-muted" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								{this.props.getUser().email}
							</button>
							<div className="dropdown-menu" aria-labelledby="dropdownMenu2">
								<button className="dropdown-item" type="button" onClick={() => {this.props.getUser(false)}}>Sign out</button>
								{DB.adminUid.indexOf(this.props.getUser().uid) >= 0? <NavLink className="dropdown-item" to="/account">Admin</NavLink> : null }
							</div>
						</div>
					</div>
				</div>
			</nav>
		);
	}
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/Pages/Navbar.js